import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router';
import { localStorage } from '../../utils'

import s from './Cookie.module.css'
import { Button, CloseIcon } from 'components/common'

const Cookie = () => {
  const router = useRouter();
  const [showCookie, setShowCookie] = useState(false)

  const cookieAcceptHandler = () => {
    localStorage.set('cookieFlag', true)
    setShowCookie(false)
  }

  useEffect(() => {
    if (!localStorage.get('cookieFlag') && router.pathname !== '/orders') {
      setTimeout(() => {
        setShowCookie(true)
      }, 3000)
    } else {
      setShowCookie(false)
    }
  }, [router.pathname])

  return (
    <>
      {showCookie && (
        <div className={s.cookie}>
          <CloseIcon
            className={s.closeIcon}
            onClick={() => setShowCookie(false)}
          />

          <h4 className={s.title}> This website uses cookies</h4>

          <div className={s.details}>
            Website uses its own and third-party cookies for statistical
            purposes, to know your preferences, for website performance and
            interaction with social media offering publicity tailored to your
            interests. If you continue browsing, we consider that you accept its
            use.
          </div>

          <div>
            <Button
              text="Accept"
              className={s.button}
              onClick={cookieAcceptHandler}
              style={{ backgroundColor: 'green' }}
            />

            <Button
              text="Dismiss"
              className={s.dismiss}
              onClick={cookieAcceptHandler}
              style={{ backgroundColor: 'red' }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default Cookie
